import axios from "axios";

// console.log('helperFunc::', JSON.parse(localStorage.getItem('token')))

var country = localStorage.getItem('country') ? JSON.parse(localStorage.getItem('country'))._id : 'all';
var userId = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).id : '';
var header = { country: country, 'company-code': 'NW', 'user-id': userId };

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 3000000000,
    headers: header
});
instance.interceptors.request.use(function (config) {
    if (!!config.data) {
        for (let key of Object.keys(config?.data)) {
            if (config.data[key] === "" || config.data[key] === undefined)
                config.data[key] = null
        }
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

// Add a response interceptor
instance.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    if (response.status === 200) {
        return response.data;
    }
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    // console.log('error::', error.response.status);
    if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        localStorage.removeItem("userData");
        localStorage.removeItem("country");
       // window.location.reload();
    }
    console.log('error-----without--token------------->:', error)
    return Promise.reject(error);
});

export default instance;